///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    // A link was clicked
    $(document).on('click', '#terms-of-use-modal .btn-primary', function () {
        window.location.reload();
        abcsetup.blockUI(true);
        $("#terms-of-use-modal").modal('hide');
        return false;
    });
});
